import type { TapEffectSpec, TapEffectVariant } from '../themes/types';
import { flyStar } from './flyStar';
import { shrinkFade } from './shrinkFade';
import { spawnSparkles } from './spawnSparkles';

export interface RunTapEffectContext {
  from: HTMLElement;
  to: HTMLElement | null;
  rewardEmoji: string;
}

const sequentialCursors = new WeakMap<TapEffectSpec, number>();

export function runTapEffect(spec: TapEffectSpec, ctx: RunTapEffectContext): void {
  const variant = pickVariant(spec);
  if (!variant) return;
  dispatch(variant, ctx);
}

function pickVariant(spec: TapEffectSpec): TapEffectVariant | undefined {
  const { variants, pickMode } = spec;
  if (variants.length === 0) return undefined;
  if (pickMode === 'random') {
    // eslint-disable-next-line sonarjs/pseudo-random -- visual variant pick, no security context
    return variants[Math.floor(Math.random() * variants.length)];
  }
  const cursor = sequentialCursors.get(spec) ?? 0;
  const variant = variants[cursor % variants.length];
  sequentialCursors.set(spec, cursor + 1);
  return variant;
}

function pickEmoji(emojis: string[] | undefined): string | undefined {
  if (!emojis || emojis.length === 0) return undefined;
  // eslint-disable-next-line sonarjs/pseudo-random -- visual emoji pick, no security context
  return emojis[Math.floor(Math.random() * emojis.length)];
}

function dispatch(variant: TapEffectVariant, ctx: RunTapEffectContext): void {
  switch (variant.kind) {
    case 'fly-to-counter': {
      if (!ctx.to) return;
      const emoji = pickEmoji(variant.emojis) ?? ctx.rewardEmoji;
      flyStar({ from: ctx.from, to: ctx.to, emoji });
      return;
    }
    case 'sparkle-burst': {
      spawnSparkles(ctx.from);
      return;
    }
    case 'shrink-fade': {
      shrinkFade(ctx.from);
      return;
    }
  }
}
